import { render, staticRenderFns } from "./pautaTrimestral_24_2020.vue?vue&type=template&id=2ea97a47&"
import script from "./pautaTrimestral_24_2020.vue?vue&type=script&lang=js&"
export * from "./pautaTrimestral_24_2020.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports